export const PHOTO_SESSION_STATUS = Object.freeze({
  ACEITO: 'Aceito',
  DESIGNADO_FOTOGRAFO: 'DesignadoFotografo',
  AGENDADO: 'Agendado',
  NAO_LISTADO: 'NaoListado',
  NOVO: 'Novo',
  INICIADO: 'Iniciado',
  FOTOS_TIRADAS: 'FotosTiradas',
  COMPLETADO: 'Completado',
  PUBLICADO: 'Publicado',
  COM_PROBLEMA: 'ComProblema',
  CANCELADO: 'Cancelado',
});

export const PHOTO_SENDER = Object.freeze({
  OWNER: 'OWNER',
  PHOTOGRAPHER: 'PHOTOGRAPHER',
});

export const DEFAULT_ROTATION_ANGLE = 90;

export const PHOTO_SESSION_JOURNEY = 'photo-session';
